// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"244":"cabd08ab","635":"b8dc7b5f","787":"7aa4962c"}[chunkId] + ".chunk.js";
};